import styled, { keyframes } from "styled-components"

const rotateKeyframes = keyframes`
    100% { transform: rotate(1turn) }
`

const Style = {
    Container: styled.div`
        position: relative;
    `,
    
    Overlay: styled.div`
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(255, 255, 255, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
    `,
    
    Loader: styled.div`
        width: 50px;
        aspect-ratio: 1;
        display: grid;
        -webkit-mask: conic-gradient(from 15deg, #0000, #000);
        mask: conic-gradient(from 15deg, #0000, #000);
        animation: ${rotateKeyframes} 1s infinite steps(12);
        
        background:
            radial-gradient(closest-side at 50% 12.5%, #ED3241 96%, #0000) 50% 0/20% 80% repeat-y,
            radial-gradient(closest-side at 12.5% 50%, #ED3241 96%, #0000) 0 50%/80% 20% repeat-x;
            
        &::before,
        &::after {
            content: "";
            grid-area: 1/1;
            background:
                radial-gradient(closest-side at 50% 12.5%, #ED3241 96%, #0000) 50% 0/20% 80% repeat-y,
                radial-gradient(closest-side at 12.5% 50%, #ED3241 96%, #0000) 0 50%/80% 20% repeat-x;
        }
        
        &::before {
            transform: rotate(30deg);
        }
        
        &::after {
            transform: rotate(60deg);
        }
    `
}

export default Style